import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicAuthLayout, { PublicAuthAlert, PublicAuthSpinner } from '../components/PublicAuthLayout';
import { forgotPassword } from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [resetUrl, setResetUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setResetUrl('');
    setLoading(true);

    try {
      const data = await forgotPassword(email);
      setMessage(data.message || 'If the account exists, a password reset link is on its way.');
      if (data.reset_url) setResetUrl(data.reset_url);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Unable to process password reset right now.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicAuthLayout
      asideBody="We will send a secure reset link to the email connected to your Seedronics workspace. Existing sessions are revoked after a successful reset."
      asideTitle="Recover access safely."
      eyebrow="Password recovery"
      footer={
        <>
          Remembered it? <Link to="/login">Back to sign in</Link>
        </>
      }
      highlights={['Secure reset link', 'Session revocation', 'Support available']}
      title="Reset your Seedronics password."
      subtitle="Enter your work email and we will guide you through the next step."
    >
      {error && <PublicAuthAlert>{error}</PublicAuthAlert>}
      {message && (
        <PublicAuthAlert tone="success">
          <span>{message}</span>
          {resetUrl && <a href={resetUrl}>Open reset link</a>}
        </PublicAuthAlert>
      )}

      {!message && (
        <form className="sd-public-auth-form" onSubmit={handleSubmit}>
          <label>
            Work email
            <input
              autoComplete="email"
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@company.com"
              required
              type="email"
              value={email}
            />
          </label>
          <button className="sd-public-auth-submit" disabled={loading} type="submit">
            {loading ? <PublicAuthSpinner /> : 'Send reset link'}
          </button>
        </form>
      )}
    </PublicAuthLayout>
  );
}
